import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { t } from 'utils/translates';

class DefaultSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectTitleNullValue:
        this.props.selectTitleNullValue !== null
          ? this.props.selectTitleNullValue
          : t('Не выбрано')
    };
  }
  getSelectValueTitle = () => {
    if (this.getSelectValue() === null || this.getSelectValue() === '') {
      if (this.props.placeholder !== null) {
        return this.props.placeholder;
      }
      return this.state.selectTitleNullValue;
    }
    return _.get(
      this.getSelectArrItems().find(i => i.value === this.getSelectValue()),
      'title'
    );
  };

  getSelectValue = () =>
    this.props.value !== null ? this.props.value.toString() : null;

  getSelectArrItems = () =>
    this.props.selectArrItems.map(item => {
      const converted = v =>
        v !== null && v !== undefined ? v.toString() : 'value_not_found';
      return {
        value: converted(item.value),
        title: converted(item.title)
      };
    });

  changeValue = async (event, newValue) => {
    event.preventDefault();
    if (newValue !== this.getSelectValue()) {
      this.props.handleChangeValue(newValue);
    }
  };

  render() {
    return (
      <React.Fragment>
        <div
          ref={this.props.innerRef}
          className="btn-group bootstrap-select form-control"
        >
          <button
            type="button"
            className={`btn dropdown-toggle bs-placeholder btn-default ${
              this.props.btnClassName
            } ${this.props.hasDisabled ? 'disabled' : ''}`}
            aria-disabled={this.props.hasDisabled ? 'true' : ''}
            data-toggle="dropdown"
            title={this.getSelectValueTitle()}
            style={
              this.props.hasDisabled
                ? { color: '#999', backgroundColor: '#f5f5f5', opacity: 1 }
                : undefined
            }
          >
            {this.getSelectValueTitle()}
          </button>
          <div
            className="dropdown-menu open"
            style={{
              maxHeight: '264px',
              overflow: 'hidden'
            }}
          >
            <ul
              className="dropdown-menu inner"
              role="listbox"
              aria-expanded="false"
              style={{
                maxHeight: '252px',
                overflowY: 'auto'
              }}
            >
              {this.state.selectTitleNullValue !== false ? (
                <li
                  className={
                    this.getSelectValue() === null ||
                    this.getSelectValue() === ''
                      ? 'active'
                      : ''
                  }
                >
                  <a href="" onClick={e => this.changeValue(e, null)}>
                    {this.state.selectTitleNullValue}
                  </a>
                </li>
              ) : null}
              {this.getSelectArrItems().map(item => (
                <li
                  key={item.title.toString()}
                  className={
                    this.getSelectValue() === item.value ? 'active' : ''
                  }
                >
                  <a href="" onClick={e => this.changeValue(e, item.value)}>
                    {item.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

DefaultSelect.defaultProps = {
  innerRef: null,
  btnClassName: '',
  value: null,
  selectTitleNullValue: null,
  placeholder: null,
  hasDisabled: false
};

DefaultSelect.propTypes = {
  innerRef: PropTypes.shape({}),
  // IN PROPS
  btnClassName: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  selectTitleNullValue: PropTypes.string,
  selectArrItems: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      title: PropTypes.string
    })
  ).isRequired,
  placeholder: PropTypes.string,
  hasDisabled: PropTypes.bool,
  handleChangeValue: PropTypes.func.isRequired
};

export default DefaultSelect;



// WEBPACK FOOTER //
// ./src/components/Common/Inputs/DefaultSelect/DefaultSelect.js